export default __webpack_public_path__ + "static/media/avatar.e413a062.png";